import { 
 //fintech
  f1,
  f2,
  f3,
  f4,
  f5,

//Social Commerce
  s1,
  SafiriSalama,
  LukuFiti,
  Rembeka,
  s4,
  s5,

//Creator Community
  c1,
  MarkMeIcons,
  c3,
  c4,
  c5,

//AI
  a1,
  a2,
  a3,
  a4,
  a5,

//moonshots & Frontier Tech
  m1,
  GoSoft,
  m2,
  m3,
  m4,
  m5,
  

  } from "../../assets"


const allProducts = [
//Fintech
  {
    id: 1,
    website: "https://intasend.com/",
    category: 'Fintech',
    name: "Intasend",
    logo: f1,
  },

//Social Commerce
  {
    id: 6,
    website: "https://rembekaonline.com/",
    category: 'Social Commerce',
    logo: Rembeka,
    name: "Rembeka",
  },
  {
    id: 7,
    website: "https://lukufiti.com/",
    category: 'Social Commerce',
    logo: LukuFiti,
    name: "LukuFiti",
  },
  {
    id: 8,
    website: "https://safirisalama.com/",
    category: 'Social Commerce',
    logo: SafiriSalama,
    name: "Safiri Salama",
  },

//Creator Community
 
  {
    id: 16,
    website: "https://useresolv.com/",
    category: 'Creator Community',
    name: "Resolv",
    logo: c1,
  },
  
//AI

//Moonshots & Frontier Tech
  {
    id: 21,
    website: "https://gosoftafrica.io",
    category: 'Moonshots & Frontier Tech',
    name: "GoSoft",
    logo: GoSoft,
  },
];
export default allProducts